import { Component } from '@angular/core';
import { FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { ResetPassword } from '../models/ResetPassword';
import { ResetPasswordService } from '../services/reset-password.service';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'reset',
  templateUrl: 'reset.component.html',
  styleUrls: ['reset.component.css']
})
export class ResetComponent extends BaseComponent {

  matchPassword: ValidatorFn = (control: AbstractControl): ValidationErrors | null => { 
    return this.passwordFormControl.value === control.value ? null : { notMatch: true }
  }

  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  passwordFormControl = new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*_\?\|\-\+~=\.\,:;\/\(\)\[\]\{\}])(?=.{8,})/)]);
  confPasswordFormControl = new FormControl('', [Validators.required, this.matchPassword]);

  resetPassword: ResetPassword = {
    code: '',
    password: ''
  };
  codeRequested = false;
  email = "";
  confirmPassword = '';
  passwordReset = false;

  constructor(public override snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private resetPasswordService: ResetPasswordService, private managerService: ManagerService) {
    super(snackBar);
  }

  ngOnInit() {
    if (this.managerService.getToken())
      this.router.navigate(['/main']);

    this.route.queryParams
      .subscribe(params => {
        this.resetPassword.code = params['code'];
      }
    );
  }

  formValid() {
    return this.passwordFormControl.valid && this.confPasswordFormControl.valid;
  }

  request() {
    if (this.emailFormControl.valid) {
      this.resetPasswordService.request(this.email).subscribe(
        () => {
          this.codeRequested = true;
        },
        error => { this.showError(error, 'Reset password request has failed due to validation'); }
      );
    }
  }

  save() {
    if (this.formValid()) {
      this.resetPasswordService.reset(this.resetPassword).subscribe(
        () => {
          this.passwordReset = true;
        },
        error => { this.showError(error, 'Password change has failed due to validation'); }
      );
    }
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}